import styled from 'styled-components';

export const Content = styled.div`
  overflow-x: hidden;
  overflow-y: auto;
  max-height: 90vh;

  .content {
    padding: 30px 0 10px;
  }

  .input-wrapper {
    padding: 0 0 20px;
    &.reason {
      padding: 0;
    }

    .label {
      padding: 0 0 10px;
      color: var(--color-text-muted);
      font-size: 12px;
      font-style: normal;
      font-weight: 500;
      line-height: 100%;
    }

    input {
      height: 40px;
    }
  }

  .checkbox-wrapper {
    display: flex;
    align-items: center;
    font-weight: 500;
    font-size: 11px;
    line-height: 100%;
    color: var(--color-text-muted);
    margin-top: 20px;
  }

  .custom-table {
    margin: 0 0 20px;
  }

  p.description {
    color: var(--color-text);
    margin: 20px 0;
    text-align: center;
  }

  .buttonContainer {
    width: 300px;
    max-width: 100%;
    display: flex;
    grid-gap: 10px;
    margin: 0 auto;
  }
`;
